import { createEdge } from "./builder";
import { LAYER_SPACING, NODE_HEIGHT, NODE_WIDTH } from "./constants";
import { nodeSize, overlaps } from "./rect";
export const EMPTY_STEP_PLACEHOLDER_NODE_ID = "empty-step-placeholder";
const OBSTACLE_GAP = 60;
export function isEmptyStepPlaceholderNode(node) {
    return node?.id === EMPTY_STEP_PLACEHOLDER_NODE_ID;
}
function rectOf(node) {
    return {
        ...node.position,
        ...nodeSize(node)
    };
}
/**
 * Right of the start node, vertical centres aligned. Shifted further right
 * past anything already there (an intermediate event, a note) so the row
 * stays straight.
 */ export function placeEmptyStepPlaceholder(start, obstacles) {
    const startRect = rectOf(start);
    const obstacleRects = obstacles.map(rectOf);
    const candidate = {
        x: startRect.x + startRect.width + LAYER_SPACING,
        y: startRect.y + startRect.height / 2 - NODE_HEIGHT / 2,
        width: NODE_WIDTH,
        height: NODE_HEIGHT
    };
    let hit = obstacleRects.find((o)=>overlaps(candidate, o));
    while(hit){
        candidate.x = hit.x + hit.width + OBSTACLE_GAP;
        hit = obstacleRects.find((o)=>overlaps(candidate, o));
    }
    return {
        x: candidate.x,
        y: candidate.y
    };
}
/**
 * Where the placeholder goes, or null when the canvas has content of its own:
 * only a draft without steps and open assignments gets one, hung off its
 * first start node and clear of every other node (events, notes).
 */ export function resolveEmptyStepAnchor(args) {
    const { process, openAssignments, nodes } = args;
    const isEmptyDraft = (process?.processStepRecordings?.length ?? 0) === 0 && (openAssignments?.length ?? 0) === 0;
    if (!isEmptyDraft) return null;
    const start = nodes.find((node)=>node.type === "flowStart");
    if (!start) return null;
    const position = placeEmptyStepPlaceholder(start, nodes.filter((node)=>node !== start));
    return {
        startEventId: start.id,
        ...position
    };
}
/**
 * The editor's empty-step placeholder and its edge from the start node. Both
 * live outside the position manager (appended like notes), so opening an
 * empty draft persists neither.
 */ export function buildEmptyStepPlaceholder(anchor, onActivate) {
    const { startEventId, x, y } = anchor;
    const position = {
        x,
        y
    };
    return {
        node: {
            id: EMPTY_STEP_PLACEHOLDER_NODE_ID,
            type: "flowEmptyStep",
            position,
            data: {
                canvasKind: "empty-step",
                onActivate: ()=>onActivate(startEventId, position)
            },
            draggable: false,
            selectable: false,
            connectable: false,
            deletable: false,
            focusable: false
        },
        edge: {
            ...createEdge(startEventId, EMPTY_STEP_PLACEHOLDER_NODE_ID),
            selectable: false,
            focusable: false,
            deletable: false
        }
    };
}

//# sourceMappingURL=emptyStepPlaceholder.js.map